import * as React from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

import { cn } from '@/lib/utils'

export const TooltipProvider = TooltipPrimitive.Provider

/**
 * A single-use tooltip: wraps `children` in a keyboard-focusable trigger
 * (so the tooltip is reachable without a mouse, per the accessibility
 * requirement) and shows `content` on hover or focus.
 */
export function Tooltip({
  content,
  children,
  className,
}: {
  content: React.ReactNode
  children: React.ReactNode
  className?: string
}) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>
        <span
          tabIndex={0}
          className={cn(
            'focus-visible:ring-ring inline-flex cursor-default rounded-sm outline-none focus-visible:ring-2',
            className,
          )}
        >
          {children}
        </span>
      </TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          sideOffset={6}
          className="border-border bg-popover text-popover-foreground z-50 max-w-xs rounded-md border px-3 py-1.5 text-xs shadow-md"
        >
          {content}
          <TooltipPrimitive.Arrow className="fill-popover" />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )
}
